import { Controller } from 'stimulus'
import { gsap } from "gsap/all"

export default class extends Controller {
  static targets = [ 'body', 'handle', 'shadow' ]

  connect() {
    if (this.state == 'close') {
      this.bodyTarget.style.display='none'
    } else {
      this.state = this.state
    }
  }

  disconnect() {
    this.dragStop()
    if (this.dialogCollectionController) this.dialogCollectionController.hideLightBox()
  }

  toggle(event) {
    if (this.drug) return this.drug = false
    if (this.state != 'open') {
      this.open(event)
    } else {
      this.minimize(event)
    }
  }

  open(event) {
    event.stopPropagation()
    this.state = 'open'
    if (this.dialogCollectionController) this.dialogCollectionController.showLightBox()
  }

  minimizeIfClosed(event) {
    if (this.state == 'close') this.state = 'minimize'
    this.element.style.zIndex = this._zIndex
  }

  close(event) {
    event.stopPropagation()
    this.state = 'close'
    if (this.dialogCollectionController) this.dialogCollectionController.hideLightBox()
  }

  minimize(event) {
    // event.stopPropagation()
    // if (this.state == 'minimize') {
    //   this.state = 'open'
    // } else {
    //   this.state = 'minimize'
    //   if (this.dialogCollectionController) this.dialogCollectionController.hideLightBox()
    // }
  }

  dragStart = (event) => {
    let style = window.getComputedStyle(this.bodyTarget)
    let matrix = new WebKitCSSMatrix(style.webkitTransform)

    this.drug = false
    this.translate = matrix.m41
    this.height = this.bodyTarget.offsetHeight
    this.startTime = Date.now()
    this.startX = this.x_for(event)
    this.startY = this.y_for(event)
    this.element.style.zIndex = this._zIndex

    window.addEventListener('mousemove', this.dragMove, false)
    window.addEventListener('mouseup', this.dragStop, false)
    window.addEventListener('touchmove', this.dragMove, false)
    window.addEventListener('touchend', this.dragStop, false)
  }

  dragMove = (event) => {
    if (Date.now() - this.startTime  > 100) {
      this.drug = true
      if (this.state == 'minimize') {
        this.data.set('state', 'open')
        this.height = this.handleTarget.offsetHeight
        gsap.to(this.bodyTarget, 0, { y: '-100%',top: '0px' , height: this.height })
      }

      let mouseX = 0
      this.lastY = this.y_for(event)
      if (this.bodyTarget.offsetWidth < window.innerWidth) mouseX = this.x_for(event) - this.startX
      gsap.to(this.bodyTarget, 0.01, { x: `${ this.translate + mouseX }px`, height: `${ Math.max(Math.min((this.height - (this.y_for(event) - this.startY)), window.innerHeight), this.handleTarget.offsetHeight) }` })
    }
  }

  dragStop = (event) => {
    window.removeEventListener('mousemove', this.dragMove, false)
    window.removeEventListener('mouseup', this.dragStop, false)
    window.removeEventListener('touchmove', this.dragMove, false)
    window.removeEventListener('touchend', this.dragStop, false)

    if (this.widthOfScreen()) {
      if (this.draggedDown()) {
        this.state = 'minimize'
        gsap.to(this.bodyTarget, 0, { height: '', delay: 0.2})
      } else {
        this.state = 'open'
        gsap.to(this.bodyTarget, 0.2, { height: window.innerHeight })
      }
    } else if (this.nearBottom())  {
      this.state = 'minimize'
      gsap.to(this.bodyTarget, 0, { height: '', delay: 0.2})
    }
  }

  draggedDown() {
    return this.startY < this.lastY
  }

  widthOfScreen() {
    return this.element.offsetWidth >= window.innerWidth
  }

  nearBottom() {
   return this.handleTarget.offsetHeight*2 > this.bodyTarget.offsetHeight
  }

  x_for (event) {
    if (event.touches) return event.touches[0].clientX
    return event.clientX
  }

  y_for (event) {
    if (event.touches) return event.touches[0].clientY
    return event.clientY
  }

  get dialogCollectionController() {
    return this.application.getControllerForElementAndIdentifier(document.body, 'dialog-collection')
  }

  get _zIndex() {
    let zIndecies = []
    for(let controller of this.application.controllers) {
      if (this.identifier == controller.identifier) {
        zIndecies.push(parseInt(controller.element.style.zIndex))
      }
    }
    return Math.max(...zIndecies) + 1
  }

  get state() {
    return this.data.get('state') || 'close'
  }

  set state(value) {
    this.data.set('state', value)
    this.element.style.zIndex = this._zIndex
    if (value == 'open')     {
      gsap.to(this.bodyTarget, 0.2, { y: '-100%', top: '0px', display: '' })
    }
    if (value == 'minimize') {
      gsap.to(this.bodyTarget, 0.2, { y: '0%', top: `-${ this.handleTarget.offsetHeight + parseInt(getComputedStyle(this.bodyTarget).paddingTop) }`, display: '' })
    }
    if (value == 'close') {
      gsap.to(this.bodyTarget, 0.2, { y: '0%', top: '0px', onComplete: () => this.bodyTarget.style.display='none' })
    }
  }
}
